// JSON-LD for the `trade` surface (`/trade/[signature]`) — an immutable
// trade record. Treated as a SocialMediaPosting.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildTradeJsonLd(
  _surface: Extract<ShareSurface, { kind: 'trade' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const headline = ctx.name ?? 'Trade on Morfi';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: headline,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SocialMediaPosting',
      '@id': `${ctx.pageUrl}#post`,
      headline,
      ...(ctx.description !== undefined ? { articleBody: ctx.description } : {}),
      url: ctx.pageUrl,
      image: ctx.ogImageUrl,
      publisher: { '@id': organizationId() },
    },
  ];
}
